export default "__VITE_ASSET__Dg$OmNeF__"